module.exports = __webpack_public_path__ + "static/media/logo.16269173.png";